import request from "@/request";
export const send_express=(data)=>request.post(`/api/admin/express/`,data)
export const edit_express=(data)=>request.patch(`/api/admin/express/${data.id}/`,data)